import { render } from "./cardStudioIT.vue?vue&type=template&id=3d252904"
import script from "./cardStudioIT.vue?vue&type=script&lang=js"
export * from "./cardStudioIT.vue?vue&type=script&lang=js"

import "./cardStudioIT.vue?vue&type=style&index=0&id=3d252904&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__